import Vue from 'vue';
import html2canvas from 'html2canvas';

Vue.prototype.$html2canvas = html2canvas;
